import React from 'react';
import { Button } from './Button';
import { FadeIn } from './ui/FadeIn';
import { Lock, Star } from 'lucide-react';
export function PricingSection() {
  const handleCheckout = () => {
    window.location.href = 'https://everithingforyou.com/cart/47902757847265:1';
  };
  return <section id="pricing" className="py-24 px-4 bg-white relative overflow-hidden" data-id="element-38">
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-gold-300 to-transparent" data-id="element-39" />

      <div className="max-w-3xl mx-auto text-center" data-id="element-40">
        <FadeIn data-id="element-41">
          <h2 className="text-4xl md:text-5xl font-serif text-burgundy-900 mb-6" data-id="element-42">
            Recupera la cercanía hoy mismo
          </h2>
          <p className="text-xl text-burgundy-700 mb-12" data-id="element-43">
            Te cuesta menos que una salida rápida… y te deja con un sistema que
            pueden repetir siempre.
          </p>
        </FadeIn>

        <FadeIn delay={200} data-id="element-44">
          <div className="bg-cream-50 rounded-3xl p-8 md:p-12 border border-cream-200 shadow-2xl relative max-w-lg mx-auto" data-id="element-45">
            <div className="absolute -top-5 left-1/2 transform -translate-x-1/2 bg-gold-500 text-white px-6 py-2 rounded-full text-sm font-bold tracking-wide shadow-lg" data-id="element-46">
              OFERTA ESPECIAL
            </div>

            <div className="mb-8" data-id="element-47">
              <span className="text-5xl md:text-6xl font-serif font-bold text-burgundy-900" data-id="element-48">
                $6.39
              </span>
              <span className="text-burgundy-600 text-lg ml-2" data-id="element-49">
                USD / pago único
              </span>
            </div>

            <ul className="text-left space-y-4 mb-10 max-w-xs mx-auto" data-id="element-50">
              <li className="flex items-center text-burgundy-800" data-id="element-51">
                <Star className="w-4 h-4 text-gold-500 mr-3 fill-current" data-id="element-52" />
                Guía digital completa (PDF)
              </li>
              <li className="flex items-center text-burgundy-800" data-id="element-53">
                <Star className="w-4 h-4 text-gold-500 mr-3 fill-current" data-id="element-54" />
                Acceso inmediato
              </li>
              <li className="flex items-center text-burgundy-800" data-id="element-55">
                <Star className="w-4 h-4 text-gold-500 mr-3 fill-current" data-id="element-56" />
                Privado y discreto
              </li>
            </ul>

            <Button onClick={handleCheckout} fullWidth className="text-lg md:text-xl py-5 mb-4 shadow-xl shadow-burgundy-900/20" data-id="element-57">
              Descargar la Guía Ahora
            </Button>

            <div className="flex items-center justify-center text-xs text-burgundy-400 gap-2" data-id="element-58">
              <Lock className="w-3 h-3" data-id="element-59" />
              <span data-id="element-60">Pago 100% seguro y encriptado</span>
            </div>
          </div>
        </FadeIn>

        <FadeIn delay={400} className="mt-16" data-id="element-61">
          <p className="text-burgundy-800 italic text-lg" data-id="element-62">
            "Si quieres que esta semana se sienta distinta — no perfecta,{' '}
            <strong data-id="element-63">distinta</strong> — entra ahora y hagan la Noche 1 hoy."
          </p>
        </FadeIn>
      </div>
    </section>;
}